export const theme = {
  text: 'white',
  background: 'black',
  font: 'Montserrat',
  primary: '#65b283',
  secondary: '#184f9d',
}

// thinking about adding a 3rd & 4th color? idk

// green #65b283  primary: '#F350F8', //pink
//  secondary: '#5A38DF', //dark blue

export const theme2 = {}
